<template>
    <div class="user-info" v-if="userInfo">
        <h2>Інформація</h2>
        <h5>Особисті дані</h5>
        <div v-if="userInfo.organizationId">
            <p>{{userInfo.fullName}}</p>
            <p>{{userInfo.email}}</p>
        </div>
        <div v-else>
            <p>{{userInfo.userInfo.surname}} {{userInfo.userInfo.name}} {{userInfo.userInfo.patronymic}}</p>
            <p>{{userInfo.email}}</p>
        </div>
    </div>
</template>

<script>
export default {
    created() {
        this.$store.dispatch('GET_USERINFO')
    },

    computed : {
        userInfo() {
            return this.$store.getters.USER_INFO;
        },
    },

}
</script>
